import ChapterElement from "./ChapterElement";
import { ChapterGroupElementProps } from "./types";

const ChapterElementGroup = ({ value }: ChapterGroupElementProps) => {
  return (
    <div className="gap-400">
      {value.map((chapter, index) => (
        <div key={`${chapter.title}-${index}`}>
          <ChapterElement value={chapter} />
        </div>
      ))}
    </div>
  );
};

export default ChapterElementGroup;
